import { DirtyModel } from "./interfaces/dirty_model";

export enum SELECTED_CURRENCY {
	CRYPTOCOIN = "cryptocoin",
	FIAT = "fiat",
	ASSET = "asset"
}

export enum TRADE_TYPE {
	BUY = "buy",
	SELL = "sell",
	DEPOSIT = "deposit",
	SWAP = "swap",
	RECURRING_BUY = "recurring-buy",
	STAKE = "stake",
	UNSTAKE = "unstake",
	CHECKOUT = "checkout",
	CLAIM = "claim",
	SELL_ORDER = "sell-order",
	BUY_ORDER = "buy-order",
	LEVERAGE = "leverage"
}

export type TradeOfferStatus = "SUCCESS" | "PENDING" | "FAILED";

export abstract class TradeOfferModel extends DirtyModel {
	protected offer_validity: number = 60; // Seconds
	protected bfc_used: boolean = false;
	protected mandate_used: boolean = false;
	protected best_amount_required_bfc: string = "";
	protected type: TRADE_TYPE = TRADE_TYPE.BUY;
	protected selected_currency: SELECTED_CURRENCY = null;
	protected asset_bonus_bfc: string = "";
	protected fiat_bonus_bfc: string = "";
	protected warnings: Warning[] = [];

	public getAssetBonusBfc(): string {
		return this.asset_bonus_bfc;
	}

	public getFiatBonusBfc(): string {
		return this.fiat_bonus_bfc;
	}

	public getMandateUsed(): boolean {
		return this.mandate_used;
	}

	public setMandateUsed(b: boolean): void {
		this.mandate_used = b;
	}

	public setFiatBonusBfc(s: string): void {
		this.fiat_bonus_bfc = s;
	}

	public setAssetBonusBfc(s: string): void {
		this.asset_bonus_bfc = s;
	}

	public get bestFeeOptIn(): boolean {
		return this.bfc_used;
	}

	public set bestFeeOptIn(b: boolean) {
		this.bfc_used = b;
	}

	public getSelectedCurrency(): SELECTED_CURRENCY {
		return this.selected_currency;
	}

	public getValidity(): number {
		return this.offer_validity;
	}

	public setValidity(n: number): void {
		this.offer_validity = n;
	}

	public get bestAmountRequiredBfc(): string {
		return this.best_amount_required_bfc;
	}

	public setType(type: TRADE_TYPE): void {
		this.type = type;
	}

	public getType(): TRADE_TYPE {
		return this.type;
	}

	public getStockWarnings(): Warning[] {
		return this.warnings;
	}

	public setStockWarnings(list: Warning[]): void {
		this.warnings = list;
	}

	public showTradingHoursWarning(): boolean {
		return this.getStockWarnings().length > 0;
	}
}

export interface Warning {
	message: string;
	link_message: string;
	// TODO remove helpdesk_article_id after completely switching to GQL. New GQL API returns the correct link.
	/**@deprecated*/
	helpdesk_article_id?: string;
	link?: string;
}
